import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-read-description',
  templateUrl: './read-description.component.html',
  styleUrls: ['./read-description.component.css']
})
export class ReadDescriptionComponent {

  @Input() description: string;
  @Input() eventAgreement: boolean = false;
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private ds: DomSanitizer
  ) { }

  ngOnInit() { }

  setMessageBody(message) {
    return this.ds.bypassSecurityTrustHtml(message.messagebody);
  }

  onClose(event: Event) {
    event.preventDefault();
    this.close.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/read-description/read-description.component.ts